import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from '../../shared';
import { MlmProgramParticipantContainerModel } from '../../../../../../models/aggregates/erp/mlm-admin';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';


@Injectable({ providedIn: 'root' })
export class MlmProgramParticipantService extends BaseApiPublicLoginTemplateService<MlmProgramParticipantContainerModel, MlmProgramParticipantContainerModel, MlmProgramParticipantContainerModel> {
  static readonly MLM_PROGRAM_PARTICIPANT_SUBPATH = 'program-participants';

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MLM_PREFIX +  MlmProgramParticipantService.MLM_PROGRAM_PARTICIPANT_SUBPATH;
  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MLM_PREFIX +  MlmProgramParticipantService.MLM_PROGRAM_PARTICIPANT_SUBPATH;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX  + Core2Config.MLM_PREFIX +  MlmProgramParticipantService.MLM_PROGRAM_PARTICIPANT_SUBPATH;

    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MLM_PREFIX + MlmProgramParticipantService.MLM_PROGRAM_PARTICIPANT_SUBPATH + "/" + BaseApiTemplateService.LOGIN_EP;

    this.httpClient = theHttp;
  }


}

